// Searchbar.js
import React from 'react';

const Searchbar = ({ searchTerm, setSearchTerm }) => {
  const SearchIcon = () => (
    <svg
      style={{ position: 'absolute', left: '12px', top: '12px', height: '16px', width: '16px' }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="11" cy="11" r="8" />
      <path d="M21 21l-4.35-4.35" />
    </svg>
  );

  return (
   <div
  style={{
    marginTop: "20px",
    marginBottom: "20px",
    display: "flex",
    justifyContent: "flex-start",
    paddingRight: "120px" 
  }}
>
      <div style={{ position: 'relative', width: '300px' }}>
          <SearchIcon/>
      <input
          type="text"
          placeholder="Search notes..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            width: '100%',
            padding: '12px 12px 12px 40px',
            border: '1px solid #d1d5db',
            borderRadius: '8px',
            fontSize: '14px',
            backgroundColor: 'white',
            boxSizing: 'border-box',
            outline: 'none',
            transition: 'all 0.2s ease',
          }}
          onFocus={(e) => {
            e.target.style.borderColor = '#d97706';
            e.target.style.outline = '2px solid #fde68a';
            e.target.style.boxShadow = '0 0 0 1.8px #fde68a80';
          }}
          onBlur={(e) => {
            e.target.style.borderColor = '#ccc';
            e.target.style.outline = 'none';
            e.target.style.boxShadow = 'none';
          }}
        />
      </div>
    </div>
  );
};

export default Searchbar;
